import { useTranslation } from 'react-i18next'
import { Text } from '@/components/ui/Text'
import type { MessageLengthHintProps } from '@/types/components/message-length-hint'
import { cn } from '@/lib/utils'

/** Matches Python and class-validator: Unicode code points, not UTF-16 units. */
export function messageCharacterCount(value: string): number {
  return Array.from(value).length
}

export function MessageLengthHint({ value, limit, id }: MessageLengthHintProps) {
  const { t } = useTranslation('app')
  const count = messageCharacterCount(value)
  if (limit === undefined || count < limit * 0.9) {
    return null
  }
  const tooLong = count > limit
  return (
    <Text
      id={id}
      role="status"
      size="sm"
      className={cn('mt-1 px-1 text-xs text-muted-foreground', tooLong && 'text-destructive')}
    >
      {tooLong ? t('chatChrome.messageTooLong', { count, limit }) : `${count} / ${limit}`}
    </Text>
  )
}
